module.exports = __webpack_public_path__ + "img/welcome.f42f7680.svg";